module.exports = __webpack_public_path__ + "static/media/faq_img_1.84206735.svg";